import React, {FC} from 'react';

import {SyncJobModel} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {ResourceMap} from '../../../../../libs/shared/core/src/store/commonAppTypes';
import {CrmSyncModel, CrmSyncStatusesEnum} from '../../../../models/api/crmSyncModel';
import {SyncJobBannerContainer} from './syncJobBannerContainer';

/*
 * Props.
 */

interface CrmSyncBannersProps {
  syncJobs: ReadonlyArray<SyncJobModel>;
  crmSyncs: ResourceMap<CrmSyncModel>;
}

/*
 * Component.
 */

export const CrmSyncBanners: FC<CrmSyncBannersProps> = ({syncJobs, crmSyncs}) => (
  <>
    {syncJobs.map((job) => {
      const crmSync = crmSyncs[job.syncId];
      if (!crmSync || crmSync.status === CrmSyncStatusesEnum.DISABLED) {
        return null;
      }
      return <SyncJobBannerContainer key={job.id} job={job} crmSync={crmSync} />;
    })}
  </>
);
